import React from 'react';
import './Rating.scss';
import Stars from './Stars/Stars';

/**
 * Renders a rating with stars and optional count
 * @param {number} stars
 * @param {string} count
 * @param {boolean} showCount
 * @param {string} starsAssetUrl
 * @returns {JSX.Element}
 * @constructor
 */
const Rating = ({ stars, count, showCount = false, starsAssetUrl }) => (
  <div className="c-rating">
    <div className="c-rating__stars">
      <Stars stars={stars} assetUrl={starsAssetUrl} />
    </div>
    {showCount && <div className="c-rating__count color-black body-2">({count})</div>}
  </div>
);

export default Rating;
